module.exports = "<ngx-monaco-editor class=\"editor\" [options]=\"options\" [(ngModel)]=\"block.backend\"></ngx-monaco-editor>\n"